import { render, staticRenderFns } from "./Breadcrum.vue?vue&type=template&id=13aded9a&"
import script from "./Breadcrum.vue?vue&type=script&lang=ts&"
export * from "./Breadcrum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports